import React from 'react';
import PropTypes from 'prop-types';

const CardHeader = ({ children, className }) => {
  return (
    <div
      className={`bg-neutral-150 text-neutral-700 rounded-t-md font-bold p-2 border-b border-neutral-300 ${className}`}
    >
      {children}
    </div>
  );
};

CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

CardHeader.defaultProps = {
  className: '',
};

export default CardHeader;
